import { logEvent } from "firebase/analytics";
import { analytics } from "./firebaseConfig";

// One place to send a GA4 event from, because `analytics` is null under the
// emulator (see firebaseConfig.js) and every call site would otherwise need the
// same guard. Local development sends nothing.
//
// .babelrc strips every console.* call but leaves logEvent alone, so these are
// the only diagnostics in the sign-in path that actually reach production.
// Every event carries the host it came from, because isProductionHost() accepts
// any *.netlify.app and so analytics is live on deploy previews too. Verifying
// these events on a preview is the intended workflow — there is nowhere else to
// do it, since sign-in needs the real auth handler — and without this the test
// runs are indistinguishable from real players in the same property. Set here
// rather than at each call site so no future event can forget it.
export default function logAnalyticsEvent(name, params) {
  if (analytics)
    logEvent(analytics, name, { ...params, host: location.hostname });
}
